/**
 * Created by eliranm on 10/11/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var BaseModel = require('models/BaseModel');

    var ContentImportErrorsModel = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        var KEYS = {
            rowIndex: 'rowIndex',
            itemId: 'Item ID',
            language: 'Language',
            title: 'Title',
            text: 'Text',
            categories: 'Categories',
            LOBs: 'LOBs',
            skills: 'Skills',
            status: 'Status',
            hotKeyLetter: 'Hot Key Letter',
            hotKeyNumber: 'Hot Key Number'
        };

        /**
         * Creates an array initialized with empty strings.
         * @param size The desired size for the result array.
         * @returns {Array} An array initialized with empty strings.
         */
        var emptyStringsArray = function (size) {
            return new Array(+size).join('.').split('.');
        };

        /**
         * Creates the defaults object with empty strings as values.
         * @returns {Object} A defaults object.
         */
        var defaults = function () {
            return _.object(_.values(KEYS), emptyStringsArray(_.keys(KEYS).length));
        };

        ContentImportErrorsModel = BaseModel.extend({
            name: "ContentImportErrorsModel",
            defaults: defaults(),

            getRowIndex: function () {
                return this.get(KEYS.rowIndex);
            },

            getItemId: function () {
                return this.get(KEYS.itemId);
            },

            getLanguage: function () {
                return this.get(KEYS.language);
            },

            getTitle: function () {
                return this.get(KEYS.title);
            },

            getText: function () {
                return this.get(KEYS.text);
            },

            getCategories: function () {
                return this.get(KEYS.categories);
            },

            getLOBs: function () {
                return this.get(KEYS.LOBs);
            },

            getSkills: function () {
                return this.get(KEYS.skills);
            },

            getStatus: function () {
                return this.get(KEYS.status);
            },

            getHotKeyLetter: function () {
                return this.get(KEYS.hotKeyLetter);
            },

            getHotKeyNumber: function () {
                return this.get(KEYS.hotKeyNumber);
            }

        });

        ContentImportErrorsModel.KEYS = KEYS;
    });

    return ContentImportErrorsModel;
})
;
